import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=c7700f0a&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7700f0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7700f0a')) {
      api.createRecord('c7700f0a', component.options)
    } else {
      api.reload('c7700f0a', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=c7700f0a&scoped=true&", function () {
      api.rerender('c7700f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8qQoQNTxTaJv9/JS/comp/Accordion.vue"
export default component.exports